/**
 * Hash-based stall/ridhus category filter for the reference archive.
 * Reads window.location.hash on load and wires up .categories-filter links.
 * Cards carry `data-cat="stall,ridhus"` (comma-separated slugs).
 */
function initReferenceFilter() {
    const filterLinks = document.querySelectorAll('.categories-filter a[data-c]');
    if (!filterLinks.length) return;

    const cards = document.querySelectorAll('.reference-grid [data-cat]');

    function applyFilter(hash) {
        cards.forEach((card) => {
            if (!hash) {
                card.classList.remove('hidden');
                card.classList.add('active');
                return;
            }
            const cats = (card.dataset.cat || '').split(',');
            if (cats.includes(hash)) {
                card.classList.remove('hidden');
                card.classList.add('active');
            } else {
                card.classList.add('hidden');
                card.classList.remove('active');
            }
        });
    }

    function getHash(url) {
        const idx = url.indexOf('#');
        if (idx === -1) return '';
        const h = url.slice(idx + 1);
        return h || '';
    }

    // Initial state
    const initial = getHash(window.location.href);
    if (initial) {
        cards.forEach((c) => c.classList.add('hidden'));
        applyFilter(initial);
        document.querySelectorAll(`.categories-filter a[data-c="${initial}"]`).forEach((l) =>
            l.classList.add('current-cat'),
        );
    }

    filterLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            filterLinks.forEach((l) => l.classList.remove('current-cat'));
            link.classList.add('current-cat');

            const cat = link.dataset.c;
            window.location.hash = cat ? `#${cat}` : '';

            if (cat) {
                cards.forEach((c) => c.classList.add('hidden'));
                applyFilter(cat);
            } else {
                applyFilter('');
            }
        });
    });

    // "Alla" link (no data-c)
    const allLink = document.querySelector('.categories-filter a:not([data-c])');
    if (allLink) {
        allLink.addEventListener('click', (e) => {
            e.preventDefault();
            filterLinks.forEach((l) => l.classList.remove('current-cat'));
            allLink.classList.add('current-cat');
            window.location.hash = '';
            applyFilter('');
        });
    }
}

export default initReferenceFilter;
